function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}


function runWithLoader(task) {
  showFabricCanvasLoader();

  // frame 1 → show loader
  requestAnimationFrame(() => {
    // frame 2 → do heavy work
    requestAnimationFrame(() => {
      task();

      // hide loader AFTER render
      setTimeout(hideFabricCanvasLoader, 150);
    });
  });
}

var text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1400, cHeight = 2164,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,
    sizeB1W = 250, sizeB1H = 250
    sizeB2W = 350, sizeB2H = 200;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


// let starimage = document.querySelector("#stars_background");
// let starBackground = new fabric.Image(starimage, {
//   left: 0,   
//   top: -50,
//   scaleX: 2,
//   scaleY: 2,
//   selectable: false
// });

// ---- Fabric Canvas Setup ----
window['canvas2'] = new fabric.Canvas('canvas2',{
  width:cWidth, height:cHeight, enableRetinaScaling:true, renderOnAddRemove:false, selection:false
});
window.canvas2.setZoom(1);
window.canvas2.requestRenderAll();

// Fix Fabric warning
if(fabric.Text && fabric.Text.prototype){ fabric.Text.prototype.textBaseline = "alphabetic"; }


// window['canvas2'].add(starBackground);
// starBackground.sendToBack();


addModify(window['canvas2']);



window.text1MaxWidth = 800;
window.text6MaxWidth = 1320;

const textLayouts = {
  "Style 1": {
    text1: {
      left: 1355,top: 2080,originX: 'right',textAlign: 'right',maxWidth: 800
    }, //your message

    text3: {
      left: 235,top: 2035
    }, //cordinates

    text6: {
      left: 30,top: 1965,originX: 'left',textAlign: 'left',maxWidth: 1320
    }, //location

    text55: {
      left: 1295,top: 2135
    }  //tasweer logo
  },

  "Style 2": {
    text1: {
      left: 695,top: 1710,originX: 'center',textAlign: 'center',maxWidth: 610
    },  //your message

    text3: {
      left: 695,top: 1882
    },  //cordinates

    text6: {
      left: 695,top: 1797,originX: 'center',textAlign: 'center',maxWidth: 610
    },  //location

    text55: {
      left: 1295,top: 2140
    }  //tasweer logo
  },

  "Style 3": {
    text1: {
      left: 1355,top: 200,originX: 'right',textAlign: 'right',maxWidth: 800
    }, //your message

    text3: {
      left: 235,top: 180
    }, //cordinates

    text6: {
      left: 30,top: 100,originX: 'left',textAlign: 'left',maxWidth: 1320
    }, //location

    text55: {
      left: 1305,top: 2140
    }  //tasweer logo
  },

  "Style 5": {
    text1: {
      left: 695,top: 1710,originX: 'center',textAlign: 'center',maxWidth: 610
    },  //your message

    text3: {
      left: 695,top: 1882
    },  //cordinates

    text6: {
      left: 695,top: 1797,originX: 'center',textAlign: 'center',maxWidth: 610
    },  //location

    text55: {
      left: 1197,top: 2015
    }  //tasweer logo
  }


};


function bringAllTextToFront() {
  const texts = [
    window.text1Page,
    // window.text2Page,
    window.text3Page,
    // window.text5Page,
    window.text6Page,
    window.text55Page
  ];

  texts.forEach(obj => {
    if (obj) {
      canvas2.bringToFront(obj);
    }
  });

  canvas2.renderAll();
}


function applyTextLayout(styleName) {

  const layout = textLayouts[styleName];
  if (!layout) return;

  const apply = (obj, key) => {

    if (window[obj] && layout[key]) {

      const settings = {
        left: layout[key].left,
        top: layout[key].top
      };

      if (layout[key].originX) {
        settings.originX = layout[key].originX;
      }

      if (layout[key].textAlign) {
        settings.textAlign = layout[key].textAlign;
      }

      window[obj].set(settings);

      // Save current style widths
      if (key === 'text1' && layout[key].maxWidth) {
        window.text1MaxWidth = layout[key].maxWidth;
      }

      if (key === 'text6' && layout[key].maxWidth) {
        window.text6MaxWidth = layout[key].maxWidth;
      }

      window[obj].setCoords();
    }
  };

  apply('text1Page', 'text1');
  apply('text3Page', 'text3');
  apply('text6Page', 'text6');
  apply('text55Page', 'text55');

  // Re-fit current text immediately
  if (window.text1Page) {
    fitTextToWidth(window.text1Page, window.text1MaxWidth);
  }

  if (window.text6Page) {
    fitTextToWidth6(window.text6Page, window.text6MaxWidth);
  }

  canvas2.renderAll();
  bringAllTextToFront();
}



$(document).ready(function () {

  let currentOverlay = null;

  function loadOverlay(url) {

    // Remove old overlay
    if (currentOverlay) {
      canvas2.remove(currentOverlay);
      currentOverlay = null;
    }

    fabric.Image.fromURL(
      url,
      function (img) {

        img.set({
          left: halfWidth,
          top: halfHeight,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false
        });

        img.scale(1);

        canvas2.add(img);

        // Keep overlay on top
        // canvas2.bringToFront(img);
        canvas2.sendToBack(img);

        currentOverlay = img;

        canvas2.renderAll();
      },
      { crossOrigin: 'anonymous' }
    );
  }

  function setActiveDesign($btn) {

  $('#map_design a').removeClass('active');
  $btn.addClass('active');

  const overlayUrl = $btn.data('overlay');

  if (overlayUrl) {
    loadOverlay(overlayUrl);
  }

  backgroundDesign = $btn.data('title');

  // ⭐ ADD THIS LINE (KEY FIX)
  applyTextLayout(backgroundDesign);
  applyImageLayout(backgroundDesign);
  }

  // =====================
  // DEFAULT LOAD (FIRST STYLE)
  // =====================
  const $defaultBtn = $('#map_design a:first');

  if ($defaultBtn.length) {
    setActiveDesign($defaultBtn);
  }

  // =====================
  // CLICK EVENT
  // =====================
  $('#map_design').on('click', 'a', function (e) {

    e.preventDefault();

    setActiveDesign($(this));

  });

});




function loadMapLibreThenInit(){
  if(window.maplibregl){
    initCityMapCustomizer();
    return;
  }

  var css=document.createElement("link");
  css.rel="stylesheet";
  css.href="https://unpkg.com/maplibre-gl@5.5.0/dist/maplibre-gl.css";
  document.head.appendChild(css);

  var script=document.createElement("script");
  script.src="https://unpkg.com/maplibre-gl@5.5.0/dist/maplibre-gl.js";
  script.onload=function(){
    initCityMapCustomizer();
  };
  script.onerror=function(){
    console.error("MapLibre failed to load.");
  };
  document.head.appendChild(script);
}

document.addEventListener("DOMContentLoaded",loadMapLibreThenInit);

function initCityMapCustomizer(){

  let pickedCoords={
    lat:31.5507,
    lon:74.3162
  };

  let pinMarker=null;
  let currentPinURL=null;
  let styleTimer=null;
  let lastQueryId=0;

  const MAPTILER_KEY="APZghV2GpndPXxXHY7XU";

  const locationInput=document.getElementById("user_location");
  const suggestions=document.getElementById("suggestions");
  const mapStyleWrap=document.getElementById("map_style");
  const bgColorInput=document.getElementById("bg_color");
  const roadColorInput=document.getElementById("road_color");
  const waterColorInput=document.getElementById("water_color");

  const MAP_THEMES={
    browngray:{background:"#443633",land:"#5D504D",water:"#B9D1DF",roads:"#e2c9ac",minorRoads:"#e2c9ac"},
    navyyellow:{background:"#0D2B45",land:"#0D2B45",water:"#FFC300",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    classic:{background:"#FFFFFF",land:"#FFFFFF",water:"#F4F4F4",roads:"#111111",minorRoads:"#111111"},
    black:{background:"#000000",land:"#050505",water:"#000000",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    darkblue:{background:"#16414d",land:"#16414d",water:"#364c59",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    blue:{background:"#086788",land:"#086788",water:"#0a1128",roads:"#c1cfda",minorRoads:"#c1cfda"},
    seagreenpink:{background:"#1caba9",land:"#1caba9",water:"#c30948",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    tasweerpurple:{background:"#58004f",land:"#58004f",water:"#e7e4ef",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    ocean:{background:"#001721",land:"#001721",water:"#51b8bf",roads:"#51b8bf",minorRoads:"#51b8bf"},
    blackgold:{background:"#1c1d22",land:"#1c1d22",water:"#c09f38",roads:"#f2cf67",minorRoads:"#f2cf67"},
    gold:{background:"#e4bf41",land:"#e4bf41",water:"#2c4131",roads:"#2c4131",minorRoads:"#2c4131"},
    pinklava:{background:"#db576b",land:"#db576b",water:"#3c6676",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    midnightblue:{background:"#3e454c",land:"#3e454c",water:"#43afaa",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    midnightpink:{background:"#2b5972",land:"#2b5972",water:"#eb9679",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    funkyorange:{background:"#fc8d12",land:"#fc8d12",water:"#009cce",roads:"#FFFFFF",minorRoads:"#FFFFFF"},
    sober:{background:"#393f4d",land:"#393f4d",water:"#bddfd1",roads:"#7e858d",minorRoads:"#7e858d"},
    lightbrown:{background:"#d1b39d",land:"#d1b39d",water:"#10788d",roads:"#987c5c",minorRoads:"#987c5c"}
  };

  function hideMapLoader(){
    const loader=document.getElementById("fabricCanvasLoader");
    if(loader){
      loader.style.display="none";
      loader.style.visibility="hidden";
      loader.style.opacity="0";
      loader.style.pointerEvents="none";
    }
  }

  hideMapLoader();

  function setInputsFromTheme(theme){
    if(bgColorInput) bgColorInput.value=theme.background;
    if(roadColorInput) roadColorInput.value=theme.roads;
    if(waterColorInput) waterColorInput.value=theme.water;
  }

  function getCurrentTheme(){
    return{
      background:bgColorInput ? bgColorInput.value : "#0D2B45",
      land:bgColorInput ? bgColorInput.value : "#0D2B45",
      water:waterColorInput ? waterColorInput.value : "#FFC300",
      roads:roadColorInput ? roadColorInput.value : "#FFFFFF",
      minorRoads:roadColorInput ? roadColorInput.value : "#FFFFFF"
    };
  }

  const liveMap=new maplibregl.Map({
    container:"live_map",
    style:"https://api.maptiler.com/maps/basic-v2/style.json?key="+MAPTILER_KEY,
    center:[pickedCoords.lon,pickedCoords.lat],
    zoom:14,
    minZoom:5,
    maxZoom:20,
    attributionControl:false,
    antialias:true,
    preserveDrawingBuffer:true,
    pitchWithRotate:false,
    dragRotate:false
  });
  
  
  window.liveMapInstance = liveMap;
  liveMap.dragRotate.disable();
  liveMap.touchZoomRotate.disableRotation();

  function isRoadLayer(id){
    return(
      id.includes("road") ||
      id.includes("street") ||
      id.includes("highway") ||
      id.includes("transport")
    );
  }

  function isWaterLayer(id){
    return id.includes("water") || id.includes("river") || id.includes("lake") || id.includes("ocean");
  }

  function shouldHideLayer(id,type){
    if(type==="symbol") return true;

    if(
      id.includes("label") ||
      id.includes("poi") ||
      id.includes("place") ||
      id.includes("boundary") ||
      id.includes("admin") ||
      id.includes("aeroway") ||
      id.includes("airport") ||
      id.includes("rail") ||
      id.includes("transit") ||
      id.includes("ferry") ||
      id.includes("building") ||
      id.includes("park") ||
      id.includes("wood") ||
      id.includes("forest") ||
      id.includes("landuse") ||
      id.includes("industrial") ||
      id.includes("school") ||
      id.includes("hospital") ||
      id.includes("pitch") ||
      id.includes("cemetery")
    ){
      return true;
    }

    return false;
  }

  function applyMapTheme(){
    if(!liveMap || !liveMap.isStyleLoaded()) return;

    const theme=getCurrentTheme();
    const style=liveMap.getStyle();

    if(!style || !style.layers) return;

    const liveMapEl=document.getElementById("live_map");
    if(liveMapEl) liveMapEl.style.backgroundColor=theme.background;

    style.layers.forEach(function(layer){
      const id=layer.id.toLowerCase();

      try{
        if(shouldHideLayer(id,layer.type)){
          liveMap.setLayoutProperty(layer.id,"visibility","none");
          return;
        }

        liveMap.setLayoutProperty(layer.id,"visibility","visible");

        if(layer.type==="background"){
          liveMap.setPaintProperty(layer.id,"background-color",theme.background);
        }

        if(layer.type==="fill"){
          if(isWaterLayer(id)){
            liveMap.setPaintProperty(layer.id,"fill-color",theme.water);
            liveMap.setPaintProperty(layer.id,"fill-opacity",1);
          }else{
            liveMap.setPaintProperty(layer.id,"fill-color",theme.land);
            liveMap.setPaintProperty(layer.id,"fill-opacity",1);
          }
        }

        if(layer.type==="line"){
          liveMap.setLayoutProperty(layer.id,"line-cap","round");
          liveMap.setLayoutProperty(layer.id,"line-join","round");

          if(isRoadLayer(id)){
            liveMap.setPaintProperty(layer.id,"line-color",theme.roads);
            liveMap.setPaintProperty(layer.id,"line-opacity",1);

            if(id.includes("minor") || id.includes("service") || id.includes("path")){
              liveMap.setPaintProperty(layer.id,"line-color",theme.minorRoads);
              liveMap.setPaintProperty(layer.id,"line-opacity",0.85);
            }
          }else if(isWaterLayer(id)){
            liveMap.setPaintProperty(layer.id,"line-color",theme.water);
            liveMap.setPaintProperty(layer.id,"line-opacity",1);
          }else{
            liveMap.setLayoutProperty(layer.id,"visibility","none");
          }
        }

        if(layer.type==="circle" || layer.type==="fill-extrusion" || layer.type==="raster"){
          liveMap.setLayoutProperty(layer.id,"visibility","none");
        }

      }catch(e){}
    });

    hideMapLoader();
  }

  // let pinMarker = null;
// let currentPinURL = null;

function removePin(){
  if(pinMarker && window.canvas2){
    window.canvas2.remove(pinMarker);
    pinMarker = null;
    window.canvas2.renderAll();
  }
}

function createPin(pinURL){
  removePin();

  currentPinURL = pinURL;

  if(!pinURL || pinURL.indexOf("map_no_pin_point") !== -1){
    return;
  }

  fabric.Image.fromURL(pinURL, function(img){

    img.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: "center",
      originY: "center",
      scaleX: 0.4,
      scaleY: 0.4,
      selectable: false,
      evented: false,
      hasControls: false,
      hasBorders: false,
      lockMovementX: true,
      lockMovementY: true
    });

    pinMarker = img;

    window.canvas2.add(pinMarker);
    pinMarker.bringToFront();

    if(window.text3Page) window.text3Page.bringToFront();
    if(window.text6Page) window.text6Page.bringToFront();

    window.canvas2.renderAll();

  }, { crossOrigin: "anonymous" });
}

function createDefaultPin(){
  const defaultPin = document.querySelector("#icon2 img");

  if(defaultPin){
    let pinURL = defaultPin.getAttribute("data-src") || defaultPin.getAttribute("src");

    createPin(pinURL);

    const icon2 = document.querySelector("#icon2");
    if(icon2) icon2.classList.add("active");
  }
}


  liveMap.on("load",function(){
    setInputsFromTheme(MAP_THEMES.blue);
    applyMapTheme();

    setTimeout(function(){
      liveMap.resize();
      createDefaultPin();
      updateCoordinates();
      hideMapLoader();
    },300);
    
  });

  liveMap.on("idle",function(){
    hideMapLoader();

    if(currentPinURL && !pinMarker){
      createPin(currentPinURL);
    }
  });

  liveMap.on("styledata",function(){
    clearTimeout(styleTimer);
    styleTimer=setTimeout(function(){
      applyMapTheme();
      hideMapLoader();
    },250);
  });

  if(mapStyleWrap){
    mapStyleWrap.querySelectorAll(".actionBtn").forEach(function(btn){
      btn.addEventListener("click",function(){

        mapStyleWrap.querySelectorAll(".actionBtn").forEach(function(el){
          el.classList.remove("active");
        });

        this.classList.add("active");

        const selected=this.getAttribute("data-style");
        const theme=MAP_THEMES[selected] || MAP_THEMES.navyyellow;

        setInputsFromTheme(theme);
        applyMapTheme();

        if(window.canvas2){
          window.canvas2.renderAll();
        }
      });
    });
  }


  function debounceStyleReload(){
    clearTimeout(styleTimer);
    styleTimer=setTimeout(function(){
      applyMapTheme();
      hideMapLoader();
    },120);
  }

  if(bgColorInput) bgColorInput.addEventListener("input",debounceStyleReload);
  if(roadColorInput) roadColorInput.addEventListener("input",debounceStyleReload);
  if(waterColorInput) waterColorInput.addEventListener("input",debounceStyleReload);

  document.querySelectorAll("#pin_design .actionBtn").forEach(function(btn){
    btn.addEventListener("click", function(){

      document.querySelectorAll("#pin_design .actionBtn").forEach(function(el){
        el.classList.remove("active");
      });

      this.classList.add("active");

      const img = this.querySelector("img");
      if(!img) return;

      let pinURL = img.getAttribute("data-src") || img.getAttribute("src");

      createPin(pinURL);
    });
  });


  liveMap.on("move",function(){
    const center=liveMap.getCenter();

    pickedCoords={
      lat:center.lat,
      lon:center.lng
    };

    // if(pinMarker){
    //   pinMarker.setLngLat([center.lng,center.lat]);
    // }
  });

  liveMap.on("moveend",function(){
    updateCoordinates();
  });

  function updateCoordinates(){
    const latDir=pickedCoords.lat>=0 ? "N" : "S";
    const lonDir=pickedCoords.lon>=0 ? "E" : "W";

    const coordsText=
      Math.abs(pickedCoords.lat).toFixed(4)+"° "+latDir+
      " - "+
      Math.abs(pickedCoords.lon).toFixed(4)+"° "+lonDir;

    const coordInput=document.getElementById("text_3");
    if(coordInput) coordInput.value=coordsText;

    if(window.text3Page){
      window.text3Page.set("text",coordsText);

      if(typeof fitTextToWidth3==="function"){
        fitTextToWidth3(window.text3Page,1200);
      }

      if(window.canvas2){
        window.canvas2.renderAll();
      }
    }
  }

  if(locationInput){
    locationInput.addEventListener("input",async function(e){
      const q=e.target.value.trim();

      if(suggestions) suggestions.innerHTML="";

      if(q.length<2){
        if(suggestions) suggestions.style.display="none";
        return;
      }

      const queryId=++lastQueryId;

      try{
        const res=await fetch(
          "https://nominatim.openstreetmap.org/search?format=json&limit=6&q="+encodeURIComponent(q)
        );

        if(queryId!==lastQueryId) return;

        const data=await res.json();

        if(suggestions) suggestions.style.display="block";

        data.forEach(function(place){
          const div=document.createElement("div");
          div.className="autocomplete-item";
          div.textContent=place.display_name;

          div.onclick=function(){
            if(suggestions) suggestions.style.display="none";

            locationInput.value=place.display_name;

            pickedCoords={
              lat:parseFloat(place.lat),
              lon:parseFloat(place.lon)
            };

            liveMap.flyTo({
              center:[pickedCoords.lon,pickedCoords.lat],
              zoom:15,
              speed:1.2,
              curve:1
            });

            // if(pinMarker){
            //   pinMarker.setLngLat([pickedCoords.lon,pickedCoords.lat]);
            // }

            if(window.text6Page){
              window.text6Page.set("text",place.display_name);

              if(typeof fitTextToWidth6==="function"){
                fitTextToWidth6(window.text6Page, window.text6MaxWidth);
              }

              window.text6Page.bringToFront();
              window['canvas2'].renderAll();
            }

            const text6Input=document.getElementById("text_6");
            if(text6Input) text6Input.value=place.display_name;

            updateCoordinates();
          };

          if(suggestions) suggestions.appendChild(div);
        });

      }catch(err){
        console.log(err);
      }
    });
  }

  const zoomInBtn=document.getElementById("zoom_in");
  const zoomOutBtn=document.getElementById("zoom_out");

  if(zoomInBtn){
    zoomInBtn.addEventListener("click",function(){
      liveMap.zoomIn();
    });
  }

  if(zoomOutBtn){
    zoomOutBtn.addEventListener("click",function(){
      liveMap.zoomOut();
    });
  }

  setTimeout(function(){
    liveMap.resize();
    applyMapTheme();
    createDefaultPin();
    hideMapLoader();
  },800);

  setTimeout(hideMapLoader,1500);
  setTimeout(hideMapLoader,3000);
}





window.waitForMapExportReady = function(map) {
  return new Promise(function(resolve) {
    if (!map) {
      resolve();
      return;
    }

    try {
      map.resize();
      map.triggerRepaint();
    } catch (e) {}

    if (map.loaded && map.loaded()) {
      requestAnimationFrame(function() {
        requestAnimationFrame(resolve);
      });
    } else {
      map.once("idle", function() {
        requestAnimationFrame(function() {
          requestAnimationFrame(resolve);
        });
      });
    }
  });
};



$('#square_image').hide();
$('#rectangle_image').hide();

window.currentImageType = 'No';

window['placeholderimg1'] = new fabric.Rect({
  left: 700,
  top: 1731,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0)',
  selectable: false
});

window['placeholderimg2'] = new fabric.Rect({
  left: 700,
  top: 1756,
  width: sizeB2W,
  height: sizeB2H,
  fill: 'rgba(0,0,0,0)',
  selectable: false
});


window['canvas2'].add(window['placeholderimg1'], window['placeholderimg2']);


const imageLayouts = {

  "Style 1": {
    square: {
      left: 695,
      top: 1731
    },
    rectangle: {
      left: 695,
      top: 1756
    }
  },

  "Style 2": {
    square: {
      left: 695,
      top: 1499
    },
    rectangle: {
      left: 695,
      top: 1527
    }
  },

  "Style 3": {
    square: {
      left: 695,
      top: 1731
    },
    rectangle: {
      left: 695,
      top: 1756
    }
  },

  "Style 5": {
    square: {
      left: 695,
      top: 1499
    },
    rectangle: {
      left: 695,
      top: 1527
    }
  }

};


window.squareUploadedImage = null;
window.rectangleUploadedImage = null;
window.squareDummyImage = null;
window.rectangleDummyImage = null;

$(window).on('load', function () {

    $('#image_type').trigger('change');

});

$('#image_type').on('change', function () {

    const value = $(this).val();

    window.currentImageType = value;

    $('#square_image').hide();
    $('#rectangle_image').hide();

    if(window.squareUploadedImage)
        window.squareUploadedImage.visible = false;

    if(window.rectangleUploadedImage)
        window.rectangleUploadedImage.visible = false;

    if(value === 'Square Image'){

        $('#square_image').show();

        if(window.squareUploadedImage){

            window.squareUploadedImage.visible = true;

            if(window.squareDummyImage)
                window.squareDummyImage.visible = false;

        }else{

            showDummyPlaceholder('Square Image');

        }

    }

    else if(value === 'Rectangle Image'){

        $('#rectangle_image').show();

        if(window.rectangleUploadedImage){

            window.rectangleUploadedImage.visible = true;

            if(window.rectangleDummyImage)
                window.rectangleDummyImage.visible = false;

        }else{

            showDummyPlaceholder('Rectangle Image');

        }

    }

    else{

        if(window.squareDummyImage)
            window.squareDummyImage.visible = false;

        if(window.rectangleDummyImage)
            window.rectangleDummyImage.visible = false;

    }

    canvas2.renderAll();

});


function prepareUploadForInput(inputId, placeholderName) {
  const input = document.getElementById(inputId);
  if (!input) return;

  input.addEventListener('change', function (e) {
    window.currentPlaceholderForCrop = window[placeholderName];
    window.reCroper = jQuery(this).parent().next().find('.btnReCrop');
    window.available_height = (window.currentPlaceholderForCrop && window.currentPlaceholderForCrop.height) || null;

    // ✅ Assign proper crop ratio
    switch (placeholderName) {
      case "placeholderimg1":
        window.sizeCrop = 1;
        break;
      case "placeholderimg2":
        window.sizeCrop = 1.98;
        break;
    }

    readURL2(e.target);
  });
}

prepareUploadForInput('image_upload_first',  'placeholderimg1');
prepareUploadForInput('image_upload_second', 'placeholderimg2');



// var maxWidth = 1200;
// var maxHeight = 240;

// var para = "check" ;

// window['text2Page'] = new fabric.Text(para,{
//   left: 680,
//   top: 1590,
//   width: 1200,
//   fontSize: 65,
//   fontFamily: 'Trajan Pro',
//   // fontWeight: 'bolder',
//   textAlign: 'center',
//   isWrapping: true,
//   fill: '#000'
// });


// var fontName = window['text2Page'].fontFamily;
// jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

// window['canvas2'].add(window['text2Page']);


// var minFontSize = 20;
// var maxFontSize = 65;

// // Clear text on input focus if default
// document.getElementById('text_2').addEventListener('focus', function () {
//   if (window['text2Page'].text === 'UNDER THIS SKY\nOUR JOURNEY BEGAN') {
//     window['text2Page'].set('text', '');
//     window['canvas2'].renderAll();
//   }
// });


// // Helper: Adjust font size to fit both width and height
// function autoFitText(textbox, maxW, maxH) {
//   let fontSize = maxFontSize;

//   textbox.set({ fontSize });

//   while (
//     (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
//     fontSize > minFontSize
//   ) {
//     fontSize -= 1;
//     textbox.set({ fontSize });
//   }

//   window['canvas2'].renderAll();
// }

// // On input update
// document.getElementById('text_2').addEventListener('input', function (e) {
//   const input = e.target.value;
//   window['text2Page'].set({
//     text: input
//   });
//   fitTextToBox(window['text2Page'], maxWidth, maxHeight);
// });

// function fitTextToBox(textObj, maxWidth, maxHeight) {
//   let fontSize = maxFontSize;

//   textObj.set({ fontSize });

//   // Helper function to get height (fabric.Text uses height property)
//   function isTooBig() {
//     return textObj.width > maxWidth || textObj.height > maxHeight;
//   }

//   // Reduce font size until both width and height fit within limits
//   while (isTooBig() && fontSize > minFontSize) {
//     fontSize -= 1;
//     textObj.set({ fontSize });
//   }

//   window['canvas2'].renderAll();
// }




window['text1Page'] = new fabric.Text('Where we said QABOOL HAI',{
  left: 680,
  top: 1740,
  fontSize: 73,
  fontFamily: 'Dancing Script',
  fill: '#000',
  // fontWeight: 'bolder',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font1').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Where we said QABOOL HAI') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 73; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], window.text1MaxWidth);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text6Page'] = new fabric.Text('Lahore',{
  left: 680,
  top: 1835,
  fontSize: 73,
  fontFamily: 'Kalam',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


var fontName = window['text6Page'].fontFamily;
jQuery('.choose_font6').val("'" + fontName + "'").trigger('change');


window['canvas2'].add(window['text6Page']);

function fitTextToWidth6(textObj, maxWidth) {
  let fontSize = 73;

  textObj.set({ fontSize });

  // 🔥 IMPORTANT: force recalculation
  textObj.setCoords();
  window['canvas2'].renderAll();

  // 🔁 Now loop correctly
  while (textObj.getScaledWidth() > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
    textObj.setCoords(); // update each loop
  }

  window['canvas2'].renderAll();
}


document.getElementById("text_6").addEventListener("input", function () {
    const val = this.value;

    if (window.text6Page) {
        window.text6Page.set("text", val);

        fitTextToWidth6(window.text6Page, window.text6MaxWidth); // 🔥 call BEFORE render

        window.text6Page.bringToFront();
        window['canvas2'].renderAll();
    }
});



// window['text5Page'] = new fabric.Text('22 May, 2025',{
//   left: 680,
//   top: 1945,
//   fontSize: 40,
//   fontFamily: 'Trajan Pro',
//   fill: '#000',
//   lockMovementX: true,
//   lockMovementY: true,
//   hasControls: false
// });

// window['canvas2'].add(window['text5Page']);





window['text3Page'] = new fabric.Text('24.8547° N - 67.0207° E',{
  left: 680,
  top: 1890,
  fontSize: 35,
  fontFamily: 'Trajan Pro',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


// Add to canvas
window['canvas2'].add(window['text3Page']);


function fitTextToWidth3(textObj, maxWidth) {
  let fontSize = 35; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}



const coordsInput = document.getElementById("text_3");





window['text55Page'] = new fabric.Text('@tasweer.com.pk',{
  left: 1310,
  top: 1955,
  fontSize: 14,
  fontFamily: 'Baloo2',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text55Page']);




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}


function applyImageLayout(styleName){

    const layout = imageLayouts[styleName];
    if(!layout) return;

    if(window.squareUploadedImage){

        window.squareUploadedImage.set({
            left: layout.square.left,
            top: layout.square.top,
            visible: (window.currentImageType === 'Square Image')
        });

        canvas2.bringToFront(window.squareUploadedImage);
    }

    if(window.rectangleUploadedImage){

        window.rectangleUploadedImage.set({
            left: layout.rectangle.left,
            top: layout.rectangle.top,
            visible: (window.currentImageType === 'Rectangle Image')
        });

        canvas2.bringToFront(window.rectangleUploadedImage);
    }


    if(window.squareDummyImage){

        window.squareDummyImage.set({
            left: layout.square.left,
            top: layout.square.top
        });

    }

    if(window.rectangleDummyImage){

        window.rectangleDummyImage.set({
            left: layout.rectangle.left,
            top: layout.rectangle.top
        });

    }

    bringAllTextToFront();

    canvas2.renderAll();
}


initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}


function getCurrentImagePosition(placeholder) {

    const currentStyle = window.backgroundDesign || 'Style 1';
    const layout = imageLayouts[currentStyle];

    if (!layout) {
        return {
            left: placeholder.left,
            top: placeholder.top
        };
    }

    // Square
    if (placeholder === window.placeholderimg1) {
        return {
            left: layout.square.left,
            top: layout.square.top
        };
    }

    // Rectangle
    if (placeholder === window.placeholderimg2) {
        return {
            left: layout.rectangle.left,
            top: layout.rectangle.top
        };
    }

    return {
        left: placeholder.left,
        top: placeholder.top
    };
}

function showDummyPlaceholder(type){

    const canvas = window.canvas2;

    let imageId, placeholder, imageRef;

    if(type === "Square Image"){

        imageId = "square_image_logo";
        placeholder = window.placeholderimg1;
        imageRef = "squareDummyImage";

    }else if(type === "Rectangle Image"){

        imageId = "rectangle_image_logo";
        placeholder = window.placeholderimg2;
        imageRef = "rectangleDummyImage";

    }else{

        if(window.squareDummyImage){
            window.squareDummyImage.visible = false;
        }

        if(window.rectangleDummyImage){
            window.rectangleDummyImage.visible = false;
        }

        canvas.renderAll();
        return;
    }

    if(window.squareDummyImage){
        window.squareDummyImage.visible = false;
    }

    if(window.rectangleDummyImage){
        window.rectangleDummyImage.visible = false;
    }

    const pos = getCurrentImagePosition(placeholder);

    if(window[imageRef]){

        window[imageRef].set({
            left: pos.left,
            top: pos.top,
            visible: true
        });

        canvas.bringToFront(window[imageRef]);
        bringAllTextToFront();
        canvas.renderAll();
        return;
    }

    const src = document.getElementById(imageId).src;

    fabric.Image.fromURL(src,function(img){

        img.set({

            left: pos.left,
            top: pos.top,
            selectable:false,
            evented:false,
            originX:'left',
            originY:'top'

        });

        img.scaleToWidth(placeholder.width);
        img.scaleToHeight(placeholder.height);

        canvas.add(img);

        window[imageRef]=img;

        canvas.bringToFront(img);

        bringAllTextToFront();

        canvas.renderAll();

    },{
        crossOrigin:'anonymous'
    });

}


function addCroppedImgForPlaceholder(placeholder, imgurl) {

    const canvas = window.canvas2;

    // Remove previous image for this placeholder
    if (placeholder === window.placeholderimg1 && window.squareUploadedImage) {
        canvas.remove(window.squareUploadedImage);
    }

    if (placeholder === window.placeholderimg2 && window.rectangleUploadedImage) {
        canvas.remove(window.rectangleUploadedImage);
    }

    fabric.Image.fromURL(imgurl, function(newImg){

        const pos = getCurrentImagePosition(placeholder);

        newImg.set({
            left: pos.left,
            top: pos.top,
            selectable: true,
            originX: 'left',
            originY: 'top'
        });

        newImg.scaleToWidth(placeholder.width);
        newImg.scaleToHeight(placeholder.height);

        canvas.add(newImg);

        if(placeholder === window.placeholderimg1 && window.squareDummyImage){

            canvas.remove(window.squareDummyImage);
            window.squareDummyImage = null;

        }

        if(placeholder === window.placeholderimg2 && window.rectangleDummyImage){

            canvas.remove(window.rectangleDummyImage);
            window.rectangleDummyImage = null;

        }


        if (
            (window.currentImageType === 'Square Image' &&
            placeholder === window.placeholderimg1)
        ) {
            newImg.visible = true;
        }
        else if (
            (window.currentImageType === 'Rectangle Image' &&
            placeholder === window.placeholderimg2)
        ) {
            newImg.visible = true;
        }
        else {
            newImg.visible = false;
        }

        // Save reference
        if (placeholder === window.placeholderimg1) {
            window.squareUploadedImage = newImg;
        }

        if (placeholder === window.placeholderimg2) {
            window.rectangleUploadedImage = newImg;
        }

        // Keep image above map
        canvas.bringToFront(newImg);

        // Keep text above image
        bringAllTextToFront();

        canvas.renderAll();

    }, {
        crossOrigin: 'anonymous'
    });
}

function initCropper() {
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: window.sizeCrop || 1, // ✅ use global ratio
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data: {}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');

  var imgurl = cropper.getCroppedCanvas().toDataURL();

  // MUST use the placeholder we saved earlier
  var placeholder = window.currentPlaceholderForCrop || window['placeholderimg1'];
  if (!placeholder) {
    console.warn('No placeholder selected for cropping. Using placeholderimg1 as fallback.');
    placeholder = window['placeholderimg1'];
  }

  // call function that replaces the image ONLY for that placeholder
  addCroppedImgForPlaceholder(placeholder, imgurl);

  setTimeout(function(){
    if (window.reCroper && window.reCroper.length) {
      window.reCroper.parent && window.reCroper.parent().removeClass('hidden');
    }
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  }, 400);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});


jQuery(document).on('click', '.btnReCrop', function () {
  loader.removeClass('hidden');

  const $btn = jQuery(this);
  const imgurl = $btn.attr('data-img');
  const dataObjName = $btn.attr('data-obj');
  const dataCanvasName = $btn.attr('data-canvas');
  const dataHeight = $btn.attr('data-height');
  const ratio = $btn.attr('data-ratio');

  // ✅ Determine correct crop ratio
  if (ratio) {
    window.sizeCrop = parseFloat(ratio);
  } else {
    switch (dataObjName) {
      case "placeholderimg1":
        window.sizeCrop = 1.98;
        break;
      case "placeholderimg2":
        window.sizeCrop = 1;
        break;
    }
  }

  // Set current placeholder and canvas
  if (dataObjName && window[dataObjName]) {
    window.currentPlaceholderForCrop = window[dataObjName];
  }

  window.reCroper = $btn;
  window.canvas = window[dataCanvasName] || window['canvas2'];
  window.available_height = dataHeight;

  // Show image in cropper popup
  jQuery('#blah').attr('src', imgurl);
  try { cropper && cropper.destroy(); } catch (e) { }
  initCropper();
  jQuery('.popupImg').show();
  loader.addClass('hidden');
});


jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], window.text1MaxWidth);
  fitTextToWidth6(window.text6Page, window.text6MaxWidth);
  // fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Where we said QABOOL HAI');
  // window['text2Page'].set('text','UNDER THIS SKY\nOUR JOURNEY BEGAN');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});


/* ======================================================
   FINAL WORKING EXPORT
   - original_image = 4000px HD
   - temp_image = 400px with placeholder/watermark
   - map zoom matches user's visible map zoom
====================================================== */

/* ======================================================
   MOBILE SAFE MAP EXPORT FIX
   - Keeps desktop HD export
   - Fixes mobile blank map issue
   - Uses safe hidden MapLibre size on mobile
   - Falls back to visible live map if HD map fails
====================================================== */

window.waitForLiveMapReady = function () {
  return new Promise(function (resolve) {
    const map = window.liveMapInstance;

    if (!map) {
      console.warn("MapLibre instance not found.");
      resolve(false);
      return;
    }

    try {
      map.resize();
      map.triggerRepaint();
    } catch (e) {}

    let done = false;

    function finish() {
      if (done) return;
      done = true;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          resolve(true);
        });
      });
    }

    if (map.loaded && map.loaded()) {
      finish();
    } else {
      map.once("idle", finish);
      setTimeout(finish, 2500);
    }
  });
};

function waitForMapIdle(map, timeoutMs) {
  return new Promise(function (resolve) {
    if (!map) {
      resolve();
      return;
    }

    let done = false;

    function finish() {
      if (done) return;
      done = true;

      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    }

    try {
      map.resize();
      map.triggerRepaint();
    } catch (e) {}

    map.once("idle", finish);
    setTimeout(finish, timeoutMs || 5000);
  });
}

function waitExtraFrames(map, frames) {
  return new Promise(function (resolve) {
    let count = frames || 6;

    function step() {
      try {
        if (map) map.triggerRepaint();
      } catch (e) {}

      count--;

      if (count <= 0) {
        resolve();
      } else {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  });
}

function loadImageFromDataURLForExport(src) {
  return new Promise(function (resolve, reject) {
    const img = new Image();

    img.onload = function () {
      resolve(img);
    };

    img.onerror = function () {
      reject("Image load failed.");
    };

    img.src = src;
  });
}

function isMobileExportDevice() {
  return (
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent) ||
    window.innerWidth <= 768
  );
}

function isUsableDataURL(dataURL) {
  return (
    typeof dataURL === "string" &&
    dataURL.indexOf("data:image/png") === 0 &&
    dataURL.length > 1000
  );
}

function getMapRectInFabricCoords(canvas) {
  const mapEl = document.getElementById("live_map");
  const fabricEl = canvas.lowerCanvasEl || canvas.getElement();

  if (!mapEl || !fabricEl) {
    console.warn("live_map or fabric canvas element not found.");
    return null;
  }

  const mapRect = mapEl.getBoundingClientRect();
  const fabricRect = fabricEl.getBoundingClientRect();

  const scaleX = canvas.getWidth() / fabricRect.width;
  const scaleY = canvas.getHeight() / fabricRect.height;

  return {
    left: (mapRect.left - fabricRect.left) * scaleX,
    top: (mapRect.top - fabricRect.top) * scaleY,
    width: mapRect.width * scaleX,
    height: mapRect.height * scaleY
  };
}

/*
  Important:
  Use CSS size, not WebGL internal canvas size.
  On mobile DPR can be 2x or 3x, and using internal canvas size
  can break zoom matching/export.
*/
function getLiveMapPixelSize(sourceMap) {
  const liveMapEl = document.getElementById("live_map");

  if (liveMapEl) {
    const rect = liveMapEl.getBoundingClientRect();

    if (rect.width > 0 && rect.height > 0) {
      return {
        width: rect.width,
        height: rect.height
      };
    }
  }

  const liveCanvas = sourceMap.getCanvas();

  return {
    width: liveCanvas && liveCanvas.clientWidth ? liveCanvas.clientWidth : 400,
    height: liveCanvas && liveCanvas.clientHeight ? liveCanvas.clientHeight : 571
  };
}

function getSafeMapRenderSize(requestedWidth, requestedHeight) {
  const isMobile = isMobileExportDevice();

  /*
    Mobile WebGL cannot safely render very large hidden canvases.
    So we render the map at a safe size, then scale it into the final 4000px export.
  */
  const maxSide = isMobile ? 1600 : 6000;
  const maxPixels = isMobile ? 2500000 : 36000000;

  let scale = 1;

  if (requestedWidth > maxSide || requestedHeight > maxSide) {
    scale = Math.min(scale, maxSide / requestedWidth, maxSide / requestedHeight);
  }

  const requestedPixels = requestedWidth * requestedHeight;

  if (requestedPixels > maxPixels) {
    scale = Math.min(scale, Math.sqrt(maxPixels / requestedPixels));
  }

  return {
    width: Math.max(1, Math.round(requestedWidth * scale)),
    height: Math.max(1, Math.round(requestedHeight * scale)),
    scale: scale
  };
}

async function captureLiveMapFallback(sourceMap) {
  try {
    await window.waitForLiveMapReady();

    sourceMap.resize();
    sourceMap.triggerRepaint();

    await waitForMapIdle(sourceMap, 2500);
    await waitExtraFrames(sourceMap, 4);

    const liveCanvas = sourceMap.getCanvas();
    const fallbackDataURL = liveCanvas.toDataURL("image/png");

    if (isUsableDataURL(fallbackDataURL)) {
      console.warn("Using visible live map fallback for mobile export.");
      return fallbackDataURL;
    }
  } catch (err) {
    console.error("Live map fallback failed.", err);
  }

  return null;
}

async function createHDMapSnapshot(mapRectFabric, exportScale) {
  const sourceMap = window.liveMapInstance;

  if (!sourceMap) {
    console.warn("Live MapLibre map not found.");
    return null;
  }

  await window.waitForLiveMapReady();

  const requestedMapWidth = Math.round(mapRectFabric.width * exportScale);
  const requestedMapHeight = Math.round(mapRectFabric.height * exportScale);

  if (requestedMapWidth <= 0 || requestedMapHeight <= 0) {
    console.warn("Invalid HD map size.", requestedMapWidth, requestedMapHeight);
    return null;
  }

  const safeSize = getSafeMapRenderSize(requestedMapWidth, requestedMapHeight);

  const renderMapWidth = safeSize.width;
  const renderMapHeight = safeSize.height;

  let hiddenWrap = null;
  let hdMap = null;
  let mapDataURL = null;

  try {
    hiddenWrap = document.createElement("div");

    /*
      Do not use left:-99999px or opacity:0 on mobile.
      Some mobile browsers skip rendering fully hidden/offscreen WebGL.
    */
    hiddenWrap.style.position = "fixed";
    hiddenWrap.style.left = "0";
    hiddenWrap.style.top = "0";
    hiddenWrap.style.width = renderMapWidth + "px";
    hiddenWrap.style.height = renderMapHeight + "px";
    hiddenWrap.style.overflow = "hidden";
    hiddenWrap.style.pointerEvents = "none";
    hiddenWrap.style.opacity = "0.001";
    hiddenWrap.style.zIndex = "0";
    hiddenWrap.style.transform = "translate3d(0,0,0)";
    hiddenWrap.style.background = "transparent";

    document.body.appendChild(hiddenWrap);

    const center = sourceMap.getCenter();
    const bearing = sourceMap.getBearing();
    const pitch = sourceMap.getPitch();

    const liveSize = getLiveMapPixelSize(sourceMap);

    const zoomRatio = Math.min(
      renderMapWidth / liveSize.width,
      renderMapHeight / liveSize.height
    );

    const correctedZoom =
      sourceMap.getZoom() + Math.log2(Math.max(zoomRatio, 1));

    let styleCopy;

    try {
      styleCopy = JSON.parse(JSON.stringify(sourceMap.getStyle()));
    } catch (e) {
      styleCopy = sourceMap.getStyle();
    }

    hdMap = new maplibregl.Map({
      container: hiddenWrap,
      style: styleCopy,
      center: [center.lng, center.lat],
      zoom: correctedZoom,
      bearing: bearing,
      pitch: pitch,
      interactive: false,
      attributionControl: false,
      preserveDrawingBuffer: true,
      antialias: true,

      /*
        Important for mobile:
        Stops iPhone/Android DPR 2x/3x from creating a huge WebGL canvas.
      */
      pixelRatio: 1
    });

    await new Promise(function (resolve) {
      hdMap.once("load", resolve);
      setTimeout(resolve, 4500);
    });

    try {
      hdMap.resize();
      hdMap.jumpTo({
        center: [center.lng, center.lat],
        zoom: correctedZoom,
        bearing: bearing,
        pitch: pitch
      });
      hdMap.triggerRepaint();
    } catch (e) {}

    await waitForMapIdle(hdMap, 6000);
    await waitExtraFrames(hdMap, 8);

    const hdCanvas = hdMap.getCanvas();

    if (hdCanvas && hdCanvas.width > 0 && hdCanvas.height > 0) {
      mapDataURL = hdCanvas.toDataURL("image/png");
    }

    console.log("Map export snapshot:", {
      requestedWidth: requestedMapWidth,
      requestedHeight: requestedMapHeight,
      renderedWidth: renderMapWidth,
      renderedHeight: renderMapHeight,
      mobile: isMobileExportDevice(),
      dataLength: mapDataURL ? mapDataURL.length : 0
    });

  } catch (err) {
    console.error("HD map snapshot failed.", err);
  }

  try {
    if (hdMap) hdMap.remove();
  } catch (e) {}

  if (hiddenWrap && hiddenWrap.parentNode) {
    hiddenWrap.parentNode.removeChild(hiddenWrap);
  }

  if (!isUsableDataURL(mapDataURL)) {
    mapDataURL = await captureLiveMapFallback(sourceMap);
  }

  return mapDataURL;
}

async function exportHDCanvasWithMap(canvas, targetWidth) {
  if (!canvas) {
    throw new Error("Fabric canvas not found.");
  }

  const baseWidth = canvas.getWidth();
  const baseHeight = canvas.getHeight();

  const exportWidth = targetWidth || 4000;
  const exportScale = exportWidth / baseWidth;
  const exportHeight = Math.round(baseHeight * exportScale);

  const mapRectFabric = getMapRectInFabricCoords(canvas);

  canvas.discardActiveObject();
  canvas.renderAll();

  const finalCanvas = document.createElement("canvas");
  finalCanvas.width = exportWidth;
  finalCanvas.height = exportHeight;

  const ctx = finalCanvas.getContext("2d");

  ctx.clearRect(0, 0, exportWidth, exportHeight);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  if (mapRectFabric) {
    const mapDataURL = await createHDMapSnapshot(mapRectFabric, exportScale);

    if (mapDataURL) {
      const mapImg = await loadImageFromDataURLForExport(mapDataURL);

      ctx.drawImage(
        mapImg,
        Math.round(mapRectFabric.left * exportScale),
        Math.round(mapRectFabric.top * exportScale),
        Math.round(mapRectFabric.width * exportScale),
        Math.round(mapRectFabric.height * exportScale)
      );
    } else {
      console.warn("Map missing. Exporting Fabric only.");
    }
  }

  const fabricDataURL = canvas.toDataURL({
    format: "png",
    multiplier: exportScale,
    enableRetinaScaling: false
  });

  const fabricImg = await loadImageFromDataURLForExport(fabricDataURL);

  ctx.drawImage(fabricImg, 0, 0, exportWidth, exportHeight);

  return finalCanvas.toDataURL("image/png");
}

function svgStringToDataURL(svgString) {
  if (!svgString) return null;

  svgString = svgString.trim();

  if (svgString.indexOf("<svg") === -1) {
    svgString =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1400 2000">' +
      svgString +
      "</svg>";
  }

  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);
}



function createTempImageWithPlaceholder(originalDataURL, targetWidth) {
  return new Promise(function(resolve, reject) {
    const baseImg = new Image();

    baseImg.onload = function() {
      const scale = targetWidth / baseImg.width;
      const targetHeight = Math.round(baseImg.height * scale);

      const tempCanvasEl = document.createElement("canvas");
      tempCanvasEl.width = targetWidth;
      tempCanvasEl.height = targetHeight;

      const tempFabric = new fabric.StaticCanvas(tempCanvasEl, {
        width: targetWidth,
        height: targetHeight,
        renderOnAddRemove: false
      });

      const fabricBaseImg = new fabric.Image(baseImg, {
        left: 0,
        top: 0,
        selectable: false,
        evented: false
      });

      fabricBaseImg.scaleToWidth(targetWidth);
      tempFabric.add(fabricBaseImg);

      const wMark = document.getElementById("wm_collage");

      if (!wMark) {
        tempFabric.renderAll();
        resolve(tempFabric.toDataURL({
          format: "png",
          multiplier: 1,
          enableRetinaScaling: false
        }));
        return;
      }

      const svgMrk = wMark.innerHTML;

      fabric.loadSVGFromString(svgMrk, function(objects, options) {
        const loadedObject = fabric.util.groupSVGElements(objects, options);

        loadedObject.scaleToWidth(targetWidth);

        loadedObject.set({
          left: targetWidth / 2,
          top: targetHeight / 2,
          originX: "center",
          originY: "center",
          objectCaching: false,
          selectable: false,
          evented: false
        });

        tempFabric.add(loadedObject);
        loadedObject.bringToFront();

        tempFabric.renderAll();

        const tempImageData = tempFabric.toDataURL({
          format: "png",
          multiplier: 1,
          enableRetinaScaling: false
        });

        tempFabric.dispose();

        resolve(tempImageData);
      });
    };

    baseImg.onerror = function() {
      reject("Original image failed to load for temp image.");
    };

    baseImg.src = originalDataURL;
  });
}

async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

/* fetch Call */
var size, thumbnail;
var loadedObject, moonDate, selectlocation, editlocation, enterText, textFont,addImage, coordinates, enterQuote, locationFont, frameColorBox, additionalInfo, wMark, svgMrk;
let pdfData = {};

jQuery(document).on('click', '#download', async function () {
  loader.removeClass('hidden');

  setTimeout(async function () {
    const id = 'canvas2';
    const canvas = window['canvas2'];

    try {
      if (!canvas) {
        throw new Error("canvas2 not found.");
      }

      canvas.discardActiveObject();
      canvas.renderAll();

      // 4000px HD original
      const originalImageData = await exportHDCanvasWithMap(canvas, 4000);

      // 400px temp image with placeholder/watermark
      window[id + 't'] = await createTempImageWithPlaceholder(originalImageData, 400);

      moonDate = jQuery('.moon_date input').val();
      selectlocation = jQuery('.location_map input').val();
      editlocation = jQuery('.edit_location input').val();
      locationFont = jQuery('.choose_font6 option:selected').val();
      enterText = jQuery('.enter_text input').val();
      textFont = jQuery('.choose_font1 option:selected').val();
      addImage = jQuery('.add_image option:selected').val();
      coordinates = jQuery('.coordinates_map input').val();
      enterQuote = jQuery('.enter_quote textarea').val();
      frameColorBox = jQuery('.frameColorBox option:selected').val();
      additionalInfo = jQuery('.tShirtImg textarea').val();

      console.log("HD original image:", originalImageData);
      console.log("400px temp image:", window[id + 't']);

      fetch('//technology-architects.com/tasweer-modules/save_order.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          temp_image: window[id + 't'],
          original_image: originalImageData
        })
      })
      .then(async function(response) {
        const text = await response.text();

        if (!response.ok) {
          throw new Error("Upload failed. Status: " + response.status + " Response: " + text);
        }

        return JSON.parse(text);
      })
      .then(function(data) {
        console.log(data);

        var previewId = data[0],
            extraImg1 = data[1];

        jQuery('#previewImg').val(previewId);
        jQuery('#preExtraImg').val(extraImg1);
        jQuery('#moonDate').val(moonDate);
        jQuery('#selectlocation').val(selectlocation);
        jQuery('#editlocation').val(editlocation);
        jQuery('#locationFont').val(locationFont);
        jQuery('#enterText').val(enterText);
        jQuery('#textFont').val(textFont);
        jQuery('#addImage').val(addImage);
        jQuery('#coordinates').val(coordinates);
        jQuery('#enterQuote').val(enterQuote);
        jQuery('#addInfo').val(additionalInfo);
        jQuery('#frameColorBox').val(frameColorBox);

        // jQuery('.product-form__buttons .product-form__submit').trigger('click');
        // loader.addClass('hidden');
        const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
      })
      .catch(function(error) {
        console.error('Error uploading images:', error);
        loader.addClass('hidden');
      });

    } catch (err) {
      console.error('Export failed:', err);
      loader.addClass('hidden');
    }

  }, 300);
});



function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}